export default __webpack_public_path__ + "static/media/remoteslider.923d4791.png";